/**
 * Badge dello stato di salute e cartellino dello stato sportivo, gli stessi in rosa,
 * elenco, scheda, formazione e cruscotto. Il disponibile e il regolare non si
 * mostrano: conta cio che cambia le scelte.
 */

import {
  ETICHETTA_STATO_GIOCATORE,
  ETICHETTA_STATO_SPORTIVO,
  type StatoGiocatore,
  type StatoSportivo,
} from '@calcio/shared';
import { Badge } from '@/components/ui/badge';
import { IconaEvento } from '../partite/eventi.js';
import { COLORE_STATO } from './colori-stato.js';
import type { StatoSportivoInCompetizione } from './elenchi.js';

export function BadgeStato({ stato }: { stato: StatoGiocatore }) {
  if (stato === 'disponibile') return null;
  return <Badge className={COLORE_STATO[stato]}>{ETICHETTA_STATO_GIOCATORE[stato]}</Badge>;
}

/**
 * Diffida o squalifica: il cartellino degli eventi, giallo o rosso, seguito
 * dal nome della competizione dove ce ne puo essere piu d'una; senza, nella
 * partita, dallo stato; nella testata della scheda, solo. La descrizione
 * completa resta come etichetta e al passaggio del mouse.
 */
export function CartellinoSportivo({
  stato,
  competizione,
  soloIcona = false,
}: {
  stato: StatoSportivo;
  competizione?: string;
  soloIcona?: boolean;
}) {
  const etichetta = ETICHETTA_STATO_SPORTIVO[stato];
  const descrizione = competizione ? `${etichetta} · ${competizione}` : etichetta;
  return (
    <span
      role="img"
      aria-label={descrizione}
      title={descrizione}
      className="inline-flex items-center gap-1 text-xs font-medium whitespace-nowrap"
    >
      <IconaEvento tipo={stato === 'squalificato' ? 'cartellino_rosso' : 'cartellino_giallo'} />
      {!soloIcona && (competizione ?? etichetta)}
    </span>
  );
}

/**
 * Stato e stati sportivi di un giocatore, per le righe di rosa ed elenco e,
 * con i soli cartellini, per la testata della scheda.
 */
export function BadgeStati({
  stato,
  statiSportivi,
  soloCartellini = false,
}: {
  stato: StatoGiocatore;
  statiSportivi: StatoSportivoInCompetizione[];
  soloCartellini?: boolean;
}) {
  return (
    <>
      <BadgeStato stato={stato} />
      {statiSportivi.map((s) => (
        <CartellinoSportivo
          key={s.competizioneId}
          stato={s.stato}
          competizione={s.competizione}
          soloIcona={soloCartellini}
        />
      ))}
    </>
  );
}
